import React, { useEffect, useState, useRef } from 'react';
function getEndTime(): number {
  try {
    const saved = localStorage.getItem('megapack_countdown_end');
    if (saved) {
      const t = parseInt(saved, 10);
      if (t > Date.now()) return t;
    }
    const t = Date.now() + 23 * 3600000 + 58 * 60000 + 33000;
    localStorage.setItem('megapack_countdown_end', t.toString());
    return t;
  } catch {
    return Date.now() + 23 * 3600000 + 58 * 60000 + 33000;
  }
}
function computeDisplay(endTime: number) {
  const d = endTime - Date.now();
  if (d <= 0) return {
    h: '00',
    m: '00',
    s: '00'
  };
  return {
    h: String(Math.floor(d / 3600000 % 24)).padStart(2, '0'),
    m: String(Math.floor(d / 60000 % 60)).padStart(2, '0'),
    s: String(Math.floor(d / 1000 % 60)).padStart(2, '0')
  };
}
export function CountdownSection() {
  const endTimeRef = useRef<number>(0);
  const rootRef = useRef<HTMLElement | null>(null);
  const intervalRef = useRef<number | null>(null);
  const [display, setDisplay] = useState({
    h: '00',
    m: '00',
    s: '00'
  });
  // Defer endTime + first display computation to idle.
  useEffect(() => {
    const init = () => {
      endTimeRef.current = getEndTime();
      setDisplay(computeDisplay(endTimeRef.current));
    };
    const w = window as any;
    const idle = w.requestIdleCallback || ((cb: () => void) => setTimeout(cb, 200));
    const handle = idle(init);
    return () => {
      if (w.cancelIdleCallback && typeof handle === 'number') {
        try {
          w.cancelIdleCallback(handle);
        } catch {}
      }
    };
  }, []);
  // Run interval only while in viewport + tab visible.
  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const start = () => {
      if (intervalRef.current != null) return;
      if (endTimeRef.current) setDisplay(computeDisplay(endTimeRef.current));
      intervalRef.current = window.setInterval(() => {
        if (!endTimeRef.current) return;
        setDisplay(computeDisplay(endTimeRef.current));
      }, 1000);
    };
    const stop = () => {
      if (intervalRef.current != null) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
    if (typeof IntersectionObserver === 'undefined') {
      start();
      return stop;
    }
    const io = new IntersectionObserver(entries => {
      for (const e of entries) {
        if (e.isIntersecting) start();else stop();
      }
    }, {
      rootMargin: '0px 0px -40px 0px',
      threshold: 0.1
    });
    io.observe(el);
    const onVisibility = () => {
      if (document.hidden) stop();else if (el.getBoundingClientRect().top < window.innerHeight) start();
    };
    document.addEventListener('visibilitychange', onVisibility, {
      passive: true
    });
    return () => {
      io.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      stop();
    };
  }, []);
  return <section ref={rootRef} className="text-white py-24 px-4 relative border-t border-[#FF1E00]/10" style={{
    background: 'linear-gradient(180deg, #2A0E0E 0%, #1A0808 40%, #110505 100%)'
  }} data-id="element-34">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-35">
        <h2 className="text-3xl md:text-5xl font-heading font-bold mb-12 md:mb-16 uppercase tracking-wide" data-id="element-36">
          ⏰ PREZZO DI LANCIO
          <br className="md:hidden" data-id="element-37" /> TERMINA IN:
        </h2>
        <div className="flex justify-center items-start gap-2 md:gap-6 mb-16 md:mb-24" data-id="element-38">
          <div className="flex flex-col items-center" data-id="element-39">
            <span className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" data-id="element-40">
              {display.h}
            </span>
            <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-41">
              HS
            </span>
          </div>
          <span className="text-6xl sm:text-7xl md:text-[120px] leading-none font-bold text-[#FF1E00] mt-1 md:mt-2" data-id="element-42">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-43">
            <span className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" data-id="element-44">
              {display.m}
            </span>
            <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-45">
              MIN
            </span>
          </div>
          <span className="text-6xl sm:text-7xl md:text-[120px] leading-none font-bold text-[#FF1E00] mt-1 md:mt-2" data-id="element-46">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-47">
            <span className="text-7xl sm:text-8xl md:text-[140px] leading-none font-heading font-black text-[#FF1E00] tracking-tighter" data-id="element-48">
              {display.s}
            </span>
            <span className="text-sm md:text-xl uppercase tracking-[0.2em] text-white/60 mt-4 font-bold" data-id="element-49">
              SEC
            </span>
          </div>
        </div>
        <p className="text-2xl md:text-4xl font-bold mb-20 md:mb-28" data-id="element-50">
          Dopo salirà di <span className="text-[#FF1E00]" data-id="element-51">€30</span> e non
          tornerà più a questo prezzo.
        </p>
        <div className="max-w-3xl mx-auto w-full mb-12" data-id="element-52">
          <div className="flex justify-between items-end mb-4 px-1" data-id="element-53">
            <div className="flex items-center gap-3" data-id="element-54">
              <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#FF1E00]" data-id="element-55"></div>
              <span className="text-[#FF1E00] font-bold text-lg md:text-2xl tracking-tight" data-id="element-56">
                Posti al prezzo di lancio
              </span>
            </div>
            <span className="text-white font-bold text-lg md:text-2xl tracking-tight" data-id="element-57">
              Pochi rimasti
            </span>
          </div>
          <div className="w-full h-5 md:h-6 bg-[#2A3441] rounded-full overflow-hidden mb-3" data-id="element-58">
            <div className="h-full rounded-full bg-gradient-to-r from-[#FF1E00] to-[#FF6B00]" style={{
            width: '68%'
          }} data-id="element-59" />
          </div>
          <div className="text-right text-white/70 text-sm md:text-base font-medium" data-id="element-60">
            68% dei posti occupati
          </div>
        </div>
        
      </div>
    </section>;
}